module.exports = __webpack_public_path__ + "img/light_float_ico.04eba750.png";